import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Priority } from '../model/Priority';
import { ScheduleInterviewSerializer } from '../model/serializer/schedule-interview-serializer';

import { environment } from '@environments/environment';
import { ScheduleInterview } from '@app/model/scheduleInterview';
import { InterviewStep } from '@app/model/interviewStep';
import { InterviewStepSerializer } from '@app/model/serializer/interview-step-serializer';

@Injectable({ providedIn: 'root' })
export class InterviewStepService extends ApiService<InterviewStep> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'interview-step',
      new InterviewStepSerializer());
  }
}
